export default "__VITE_ASSET__D$yt87Th__"